import { useState } from "react";

export function SafeImage({ src, alt, className = "", label = "CLB" }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-navy ${className}`} aria-label={alt}>
        <span className="font-display text-2xl font-semibold tracking-[0.3em] text-gold">{label}</span>
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
    />
  );
}
